import { useDomainAccessControl } from 'domains/reports/utils/domain/accessControl'
import { Flipper } from 'domains/reports/access-control/flippers'

export const useIsPpdoTogglesEnabled = () => {
  const hasAccess = useDomainAccessControl()
  return hasAccess([
    { flippers: Flipper.PpdoAnalyticsToggles, warehouseFlippers: [Flipper.PpdoAnalyticsToggles] },
  ])
}
